/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import gql from "graphql-tag";
export const GET_SHELF_DETAIL = gql`

query GetShelf(
  $shelfFilter: UniqShelfFilterInput!
  $getDistCentsFilter: DistCentFilterInput
   $filters: ShelfFilterInput
) {
  getShelf(filter: $shelfFilter) {
    activeStatus
    boxesCount
    createdAt
    _id
    undeliveredBoxesCount
    name
    shelfDeliveryStatus
    shelfId
    distCent {
      id
      name
    }
  }
  getShelves(filters: $filters) {
    content {
      _id
      name
      shelfId
    }
  }
  getDistCents(filter: $getDistCentsFilter) {
  content {
    id
    name
    noOfCounters
  }
}
}
`;
